import data from "./defaultRealTeamInfo.json";
import photos from "./defaultRealPlayerPhotos.json";
import { realTeamInfoSchema, realPlayerPhotosSchema } from "./types.ts";

export const defaultRealTeamInfo =
	__SPORT === "basketball" ? realTeamInfoSchema.parse(data) : undefined;

export const defaultRealPlayerPhotos =
	__SPORT === "basketball" ? realPlayerPhotosSchema.parse(photos) : undefined;
